<template>
  <div ref="wrapRef" class="dict-select" :style="props.style">
    <a-select
      v-model:value="localValue"
      style="width: 100%"
      :options="localOptions"
      :allow-clear="allowClear"
      :placeholder="placeholder"
      popup-class-name="dict-select-dropdown"
      :dropdown-style="{ zIndex: 999 }"
      :get-popup-container="getPopupContainer"
      @select="handleSelect"
      @change="handleChange"
    ></a-select>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, type CSSProperties } from 'vue'
import { useDict } from '@/hooks/useDict'

defineOptions({
  name: 'DictSelect',
})

type Props = {
  style?: CSSProperties
  allowClear?: boolean
  placeholder?: string
  dict: string // 字典关键字
  keyOption?: { labelKey: string; valueKey: string } // 字典项的 label 和 value 对应的键名
  hasFull?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  style: () => ({ width: '100%' }),
  allowClear: false,
  placeholder: '请选择',
  dict: '',
  keyOption: () => ({ labelKey: 'itemName', valueKey: 'itemCode' }),
  hasFull: false,
})

type Option = {
  class: string
  disabled: boolean
  key: string
  title: string
  value: string | number | undefined
}

const emit = defineEmits<{
  (e: 'change', value: string | null, option: Option): void
  (e: 'select', value: string | null, option: Option): void
}>()

const localValue = defineModel<string | null>('value', {
  default: null,
})

const wrapRef = ref<HTMLElement | null>(null)

/** 挂到组件容器内，避免下拉层挂到 body 后盖住 sticky 顶栏 */
const getPopupContainer = () => wrapRef.value || document.body

const { dictList, fetchDict } = useDict(props.dict, props.keyOption)
fetchDict()
const localOptions = ref<{ label: string; value: ID }[]>([])

watch(
  () => dictList.value,
  () => {
    localOptions.value = dictList.value
    if (props.hasFull) {
      localOptions.value.unshift({ label: '全部', value: null })
      console.log('hasFull', localOptions.value)
    }
  },
  { immediate: true }
)

const handleSelect = (value: string | null, option: Option) => {
  emit('select', value, option)
}

const handleChange = (value: string | null, option: Option) => {
  emit('change', value, option)
  console.log('change', value, option)
}
</script>

<style lang="less">
.dict-select {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  overflow: visible;
}

/* 顶栏 z-index 为 1100，下拉层不得高于顶栏 */
.ant-select-dropdown.dict-select-dropdown {
  z-index: 999;
}
</style>
